/*
----- Axis Mobile Menu ----- 
The core functionality to join menu's from different places in the DOM into one container to be displayed in mobile ( i.e the top bar navigation gets merged with the main menu bar ).
*/

var instances = {};

function setContext(id, value) {
    return instances[id]['context'] = value;
}

function getContext(id) {
    return instances[id]['context'];
}

function setMenus(id, value) {
    return instances[id]['menus'] = value;
}

function getMenus(id) {
    return instances[id]['menus'];
}

// If mobile menu's were active and the viewport changes then 
$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
    // Get current breakpoint.
    let breakpoint = currentBreakpoint();
    // If >= large then get all mobile menu instances.
    if (breakpoint >= 3) {
        // Get all elements.
        let elements = $('[' + expressSelectors()['mobile-menus']['initialise'] + ']');
        // Fallback.
        if (!elements.length) {
            elements = $('.header-mobile-menu');
        }
        // Check if any elements are active.
        if (elements.hasClass('active') || elements.hasClass('animate')) {
            // Remove classes.
            elements.removeClass('active');
            elements.removeClass('animate');
            // If blur is active then remove it.
            if (isBlurContentActive()) {
                blurContent(getBlurContent(), true);
                // Re-enable body scrollbar.
                bodyScrollLock();
            }
        }
    }
});


function initialiseAll() {
    // Get all elements.
    let elements = $('[' + expressSelectors()['mobile-menus']['initialise'] + ']');

    if (elements.length) {
        elements.each(function() {
            // Get context.
            let element = $(this);
            // Initialise.
            let init = initialise(element);
        });
    }
}

// Initialise Specific instance.
function initialise(context) {
    // Get instance id.
    let id = context.attr(expressSelectors()['mobile-menus']['initialise']);
    // If no Id then generate one.
    if (!id) {
        // Generate +  assign id.
        context.attr(expressSelectors()['mobile-menus']['initialise'], generateId());
        // Get instance id.
        id = context.attr(expressSelectors()['mobile-menus']['initialise']);
        // Create instances.
        instances[id] = {};
        // Update instace.
        setContext(id, context);
    } else {
        return false;
    }

    let group = context.attr(expressSelectors()['mobile-menus']['container']);
    if (!group) {
        console.error("Mobile Menus: You must provide a group id");
        return false;
    }
    // Find Menus.
    let menus = $('[' + expressSelectors()['mobile-menus']['child-menu'] + '="' + group + '"]');


    // Is the menu already inside of the mobile menu container? 
    let alreadyInContainer = false;
    // Sort through menus.
    menus.each(function() {
        // Menu context.
        let menu = $(this);
        // Check if in container.
        alreadyInContainer = (menu.parents('[' + expressSelectors()['mobile-menus']['container'] + '="' + group + '"]').length);
    });

    // If already in container then skip.
    if (alreadyInContainer) {
        return true;
    }

    // Find content container.
    let contentContainer = context.find('.content-container');
    // If there is not one then generate one.
    if (!contentContainer.length) {
        context.html('<div class="content-container"></div>');
    }

    // Does context have a header?
    let hasHeader = (context.find('.menu-header').length > 0);
    if (!hasHeader) {
        menus.each(function() {
            // Menu context.
            let menu = $(this);
            // Is this a mega menu?
            let isMegaMenu = (menu.parents('[' + expressSelectors()['mega-menu']['initialise'] + ']').length > 0);
            // Fallback.
            if (!isMegaMenu) {
                // Check on context.
                isMegaMenu = (menu.attr(expressSelectors()['mega-menu']['initialise']) != undefined);
            }
            // If this is a mega menu and there is no header.
            if (isMegaMenu) {
                let mobileMenuContext = menu.parents('.header-mobile-menu');
                if (!mobileMenuContext.length) {
                    AXISDebug.output(3,"Mobile Menus: Could not find mobile menu container", menu);
                    return false;
                }
                // Find header.
                let header = mobileMenuContext.find('.menu-header');
                if (!header.length) {
                    AXISDebug.output(3,"Mobile Menus: Could not find header", menu);
                    return false;
                } else {
                    context.find('.content-container').html(header);
                }
            }
        });
    }
    
    // Update instace.
    setMenus(id, menus);

    buildMenus(id);
}

function buildMenus(id) {
    // Get Menus.
    let menus = getMenus(id);
    // Get where we're about to insert these menus.
    let container = getContext(id);
    // Loop from menus.
    menus.reverse().each(function() {
        // Menu context.
        let menu = $(this);
        // Clone the menu.
        menu = menu.clone();
        // Add mobile only class.
        menu.addClass('hide-for-large');
        // Add menu to the container.
        container.prepend(menu);

        // Does the container have a content container?
        let content = container.find('.content-container');
        if (content.length) {
            // Then insert after the menu-header.
            menu.insertAfter(container.find('.menu-header'));
        } else {
            // Else just append the container.
            container.prepend(menu);
        }
        AXISResponsiveMenu.initialise(container.find(menu));
    });
}


var AXISMobileMenus = $.AXISMobileMenus = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        return initialise(context);
    }
}

export { AXISMobileMenus };